import React from 'react';

// tslint:disable max-line-length
const CLetThemKnowPart2TranscriptMunch: React.FC = () => (
  <>
    <h5>Record a message for part 2</h5>
    <p>Time for your second message, to go along with your photo.  I can’t help you on this one – sorry – it’s better if it comes from you. When you’re ready, hit record.</p>
  </>
);

export {
  CLetThemKnowPart2TranscriptMunch,
};
